<template lang="pug">
  v-dialog(v-model='dialog' persistent)
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.activity') }}
        v-spacer
        v-btn(icon @click="$emit('close')")
          v-icon close
      v-card-text
        v-text-field.mb-2(v-model='search', append-icon='search', label='Search', single-line, hide-details)        
        v-data-table(:headers='headers', :items='activity', :search="search", :loading='loading', :pagination.sync='pagination')
            template(slot='items', slot-scope='props')
              td.text-xs-left {{ $moment(props.item.createdAt).format('MM/DD/YYYY h:m a') }}
              td.text-xs-left {{ props.item.userName }}
              td.text-xs-left {{ props.item.activity }}
              td.text-xs-left {{ props.item.data }}
            v-alert(slot='no-results', :value='true', color='error', icon='warning')
              | Your search for "{{ search }}" found no results.
        
</template>

<script>
import activityService from '../service.js'

export default {
  name: 'activity',
  props: ['refID', 'typeId', 'activityDialog'],
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: this.$t('labels.createdAt'),
          value: 'createdAt',
          sortable: true,
        },
        {
          text: this.$t('labels.userName'),
          value: 'userName',
          sortable: true,
        },
        {
          text: this.$t('labels.activity'),
          value: 'activity',
          sortable: true,
        },
        {
          text: this.$t('labels.description'),
          value: 'data',
          sortable: true,
        },
      ],
      search: null,
      activity: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'id',
        descending: true,
      },
    }
  },
  watch:{
    activityDialog(val) {
      this.dialog = val
      this.getList()
    }
  },
  methods: {
    getList() {
      this.loading = true
      return activityService
      .getActivityByID({typeID: this.typeId, id: this.refID})
      .then((response) => {
        this.activity = response
        this.loading = false
        return response
      })
    }
  }
}
</script>

<style scoped>
</style>